import { render, staticRenderFns } from "./BibleTranslations.vue?vue&type=template&id=abd3856e"
import script from "./BibleTranslations.vue?vue&type=script&lang=js"
export * from "./BibleTranslations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports